//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from "quasar";
import { mapActions } from "vuex";
import router from "../../router";
export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "orderNumber",
        descending: true,
      },
      orders: [],
      orderOptions: [
        { value: 41001, name: this.$t("order.status-41001") },
        { value: 41002, name: this.$t("order.status-41002") },
        { value: 41003, name: this.$t("order.status-41003") },
        { value: 41004, name: this.$t("order.status-41004") },
        { value: 41005, name: this.$t("order.status-41005") },
      ],
      orderStatuses: [41002, 41003],
      filter: "",
      customers: [],
      title: this.$t("headers.salesOrder"),
      orderId: 0,
      dense: true,

      columns: [
        {
          name: "orderNumber",
          align: "left",
          label: this.$t("order.orderNo"),
          style: "width: 200px",
          field: "orderNumber",
          sortable: true,
        },

        {
          name: "customerNumber",
          align: "left",
          label: this.$t("order.customerNumber"),
          field: "customerNumber",
          sortable: true,
        },

        {
          name: "customerName",
          align: "left",
          label: this.$t("order.customerName"),
          field: "customerName",
          sortable: true,
        },
        {
          name: "ourReference",
          align: "left",
          label: this.$t("order.ourReference"),
          field: "ourReference",
          sortable: true,
        },

        {
          name: "orderDate",
          align: "left",
          label: this.$t("order.orderDate"),
          field: "orderDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("order.deliveryDate"),
          field: "deliveryDate",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "deliveryMethod",
          align: "left",
          label: this.$t("order.deliveryMethod"),
          field: "deliveryMethod",
          sortable: true,
        },
        {
          name: "customerOrderStatusId",
          align: "left",
          label: this.$t("order.customerOrderStatusId"),
          field: "customerOrderStatusId",
          format: (val) => this.$t("order.status-" + val),
          sortable: true,
        },
      ],
      columnsOrderLine: [
        {
          name: "productNumber",
          align: "left",
          label: this.$t("order.productNumber"),
          field: (row) => row.productNumber,
          sortable: true,
        },
        {
          name: "productName",
          align: "left",
          label: this.$t("order.productName"),
          field: (row) => row.productName,
          sortable: true,
        },

        {
          name: "quantity",
          align: "left",
          label: this.$t("order.quantity"),
          field: (row) => row.numberOfItems,
          sortable: true,
        },
        {
          name: "deliveryDate",
          align: "left",
          label: this.$t("order.deliveryDate"),
          field: (row) => row.deliveryDate,
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
      ],
    };
  },
  async mounted() {
    await this.refresh();
  },

  watch: {
    orderStatuses(newValue, oldValue) {
      if (newValue != oldValue) {
        this.refresh();
      }
    },
  },
  methods: {
    openOrder(orderId) {
      router.push({ name: "Order", params: { id: orderId } });
    },

    async refresh() {
      this.orders = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      console.log(this.orderStatuses);

      this.orders = await this.getOrdersByStatuses(this.orderStatuses);

      setTimeout(() => {
        notif();
      }, 500);
    },

    ...mapActions("main", ["getOrders", "getOrdersByStatuses"]),
  },
};
